module.exports = __webpack_public_path__ + "static/media/board_selected.c163e031.svg";